import styled from '@emotion/styled';
import { N400 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const KeyboardShortcutContainer = styled.div({
  display: 'flex',
  lineHeight: '16px',
  alignItems: 'center',
  paddingBottom: "var(--ds-space-025, 2px)",
  paddingTop: "var(--ds-space-025, 2px)"
});

// TODO: https://product-fabric.atlassian.net/browse/DSP-3457
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const KeyboardShortcut = styled.div({
  backgroundColor: `var(--ds-background-neutral, ${N400})`,
  border: `1px solid ${`var(--ds-text-inverse, ${N400})`}`,
  borderRadius: '2px',
  marginLeft: "var(--ds-space-050, 4px)",
  padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
  lineHeight: '16px'
});